/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Contains the names of all the linked lists available for @see {@link Synqo.Cloud.Stammdaten.Model.Api.ApiAddress}
 */
export class AddressLinkLists {
    /**
     * Represents a list of linked contact persons
     */
    static readonly contacts: string = 'contacts';
    /**
     * Represents a list of linked customers (addresses)
     */
    static readonly customers: string = 'customers';
    /**
     * Represents a list of linked locations (addresses)
     */
    static readonly locations: string = 'locations';
}
